import { useTranslation } from 'react-i18next';
import {
  arrowRightThinSVG,
  warningWithCircleSVG,
} from '../../lib/allCustomSVGs';
import '../../styles/cards/pageBlocker.scss';
import CustomSVGs from '../customSVGs/CustomSVGs';
import { useLocation, useNavigate } from 'react-router-dom';

const PageBlocker = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';

  const renderDashboardBlocker = () => {
    return (
      <div className='dashboardBlocker'>
        <div className='dashboardBlocker-warning'>
          <CustomSVGs svg={warningWithCircleSVG} />
          <span>{t('ActionRequired')}</span>
        </div>
        <div className='dashboardBlocker__content'>
          <h2>{t('SetUpAdUpAITracking')}</h2>
          {isDashboard ? (
            <p>{t('YouNeedToSetUpAdUpAITrackingInDashboard')}</p>
          ) : (
            <p>{t('YouNeedToSetUpAdUpAITrackingInRecommendations')}</p>
          )}

          <div
            onClick={() => {
              navigate('/integrations');
            }}
            className='dashboardBlocker__content--button'
          >
            <span>{t('SetUpTrackingNow')}</span>
            <CustomSVGs svg={arrowRightThinSVG} />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className='pageBlocker'>
      <div className='pageBlocker__content'>{renderDashboardBlocker()}</div>
    </div>
  );
};

export default PageBlocker;
